import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import TableSort from '../tableComponents/TableSort'
import { formatDateRange } from "../js/utilityRoutines"

const enspace = String.fromCharCode(8194)

export default function WindroseTable(props) { 
  const { hcdata, userParams, windtableData } = props;
  const { tabledata, sumObs, sumMiss, dayFilter, hourFilter } = windtableData;
  const [ heads, setHeads ] = useState();
  const dateRange = formatDateRange(userParams);
  const dirUnits = userParams.directbincnt === 16 ? 'compass' : 'degrees'
  const dayFilterText = dayFilter ? (enspace + dayFilter + '.') : ""
  const hourFilterText = hourFilter ? (enspace + hourFilter + '.') : "";
  const titleText = "Wind Frequency Table ("+userParams.pctcnt+")<br />"+hcdata.title.text;
  const footerText = "Based on a total of "+sumObs+" hourly observations; "+sumMiss+" missing."+
    "<br />" + dateRange +
    dayFilterText +
    hourFilterText +
    "<br />Wind speed bins ("+userParams.wsunits+") include values greater than the lower end of the range and less than or equal to the upper end."

  useEffect(() => {
    const headRow = []
    headRow.push(
        {text: "", id: "index", invisible: true, initSort: true, sortOrder: "asc"},
        {text: "Wind Direction (" + dirUnits + ")", id: "wdir", component: "th", altSort: "index"}
    )
    hcdata.series.map((row,i) => {
      headRow.push({text: row.name, sx: { whiteSpace: "nowrap"}, id: i})
    })
    headRow.push(
      {text: "All speeds", id: "all"},
      {text: "Average speed", id: "avg"}
    )
    setHeads(headRow)
  }, [])

  return (
    <Box sx={{my: 1}}>
      {heads &&
        <TableSort 
          titleText={titleText} 
          heads={heads}  
          tabledata={tabledata} 
          footerText={footerText}
        />
      }
    </Box>
  )
}